import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField,  Typography, Button, CircularProgress } from "@mui/material";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
export default function Report() {
  const [datasource, setDatasource] = useState([]);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  useEffect(() => {
    fetchReportData();
  }, []);
  const fetchReportData = async () => {
    setLoading(true);
    try {
      let url = webEndPoint + "productAttributes";
      const response = await makeRequest("get", url);
      if (response) {
        setDatasource(response?.data);
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const handleExportCSV = () => {
    if (!datasource || datasource.length === 0) {
      setMessage("No data to export");
      setSnackbar(true);
      return;
    }
    const headers = ["S.No", "Product Name", "Color", "Age / Size", "Current Stock"];
    const csvRows = [
      headers.join(","),
      ...datasource.map((item, index) => [
        index + 1,
        item.product_name,
        item.color_name,
        item.age_name ? item.age_name : item.size_name,
        item.retail_quantity
      ].join(","))
    ];
    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const filteredState = datasource?.filter((d) =>
    d?.product_name?.toLowerCase().includes(search?.toLowerCase())
  );
  const columns = ["S.No", "Product Name", "Color", "Age / Size", "Current Stock"];
  const rows = filteredState?.map((sizes, index) => [index + 1, sizes.product_name, sizes.color_name, sizes.age_name ? sizes.age_name : sizes.size_name, sizes?.retail_quantity
  ]);
  return (
    <Box sx={{ position: "relative" }}>
      {loading && (
        <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
          <CircularProgress />
        </Box>
      )}
      <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Stock Report</Typography>
      <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
        <TextField label="Search Product Name" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
        <Button variant="contained" startIcon={<FileDownloadIcon />} onClick={handleExportCSV}>Export CSV</Button>      </Box>
      <DataTable columns={columns} rows={rows} />
      <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
    </Box>
  );
}